var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-body"},[_c('div',{staticStyle:{"font-size":"22px","color":"#409EFF","cursor":"pointer"},on:{"click":function($event){return _vm.$router.push('/erp-store-log-manager')}}},[_vm._v("该功能已迁移至库存管理-库存记录,点击前往")])])
}
var staticRenderFns = []

export { render, staticRenderFns }